module.exports = __webpack_public_path__ + "img/LineSpot.cf6517a7.png";